import React from 'react';
import { getThemeCSSVars } from '../../utility/themeVars';
import { getMarketingUrl } from '../../utility/environment';
import { getBrandName } from '../../utility/branding';

const PublicBookingLayout = ({ children, primaryColor = 'blue-600', themeMode = 'light' }) => {
  const themeVars = getThemeCSSVars(primaryColor, themeMode);
  const themeBgPage = themeVars['--theme-bg-page'];

  React.useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--theme-bg-page', themeBgPage);
    return () => {
      // Only clear if we're still the writer — a later mount may have
      // overwritten our value (React 18 strict mode, Suspense transitions).
      if (root.style.getPropertyValue('--theme-bg-page') === themeBgPage) {
        root.style.removeProperty('--theme-bg-page');
      }
    };
  }, [themeBgPage]);

  return (
    <div className="min-h-screen flex flex-col bg-themed-page" style={themeVars}>
      <div className="flex-1 w-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </div>

      {/* Powered by brand badge */}
      <div className="mt-auto mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 pt-8 pb-8 border-t border-opacity-20 border-ink-200">
        <div className="text-center">
          <a
            href={getMarketingUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-themed-secondary transition-colors duration-200 hover:opacity-80"
          >
            <div className="text-xs font-medium">
              Get your own booking page
            </div>
            <div className="text-[10px] mt-1 opacity-70">
              Powered by {getBrandName()}
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PublicBookingLayout;